import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import MaterialModal from "../../../../app/material-modal";

export function StartDateModal({
  open,
  handleClose,
  setInviteList,
}) {
  const [startDate, setStartDate] = useState(null);
  const [startDateError, setStartDateError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!startDate) {
      setStartDateError(true);
      return;
    }
    const formattedDate = startDate?.format("ddd, DD MMM YYYY HH:mm:ss [GMT]");

    setInviteList((prev) => ({
      ...prev,
      startDate: formattedDate,
    }));

    setStartDateError(false);
    handleClose();
  };


  return (
    <MaterialModal
      open={open}
      handleDialogClose={handleClose}
      styleOverrides={{
        container: {
          "& .MuiDialog-paper": {
            width: "100%",
            maxWidth: "500px",
            ".MuiDialogContent-root": {
              overflow: "auto",
            },
          },
        },
      }}
      title="Start Date"
    >
      <form onSubmit={handleSubmit}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

          <Stack direction="row" alignItems="center">
            <Box sx={{ flexBasis: "40%" }}>
              <Typography sx={{ fontWeight: "bold" }}>Start Date</Typography>
            </Box>
            <Box sx={{ flexBasis: "60%" }}>
              <DatePicker
                value={startDate}
                onChange={(newValue) =>{ 
                    setStartDate(newValue)
                    setStartDateError(false)
                }}
                sx={{
                  ".MuiInputBase-input": {
                    padding: "8px 8px",
                    fontSize: "14px",
                  },
                }}
                slotProps={{
                  textField: {
                    error: startDateError,
                    helperText: startDateError ? "Start date is required" : "",
                  },
                }}
              />
            </Box>
          </Stack>

          {/* Footer */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              type="submit"
            >
              Assign Date
            </Button>
          </Box>
        </Box>
      </form>
    </MaterialModal>
  );
}
